import Router from 'next/router';
import { useCallback } from 'react';

import { Routes } from '~/constants/routes';
import { buildShowcaseOpenQuery } from '~/utils/showcasesListQuery';

/** Navigates to the in-product showcase editor for a collection id. */
export const useOpenWorkspaceAgentShowcaseSettings = () => {
  const openShowcaseSettings = useCallback((collectionId: string) => {
    void Router.push({
      pathname: Routes.showcases,
      query: buildShowcaseOpenQuery({}, collectionId),
    });
  }, []);

  return { openShowcaseSettings };
};
